{
  "id": "campaign-063",
  "name": "Mossy Hole",
  "seed": "campaign:63",
  "startDir": "W",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    "............",
    "...www......",
    "...www......",
    "..W..,...W..",
    ".#..,ooo..,.",
    ".....oFo,,,,",
    ".....ooo..,.",
    "....T..Tss..",
    ".........s.x",
    "..W......W..",
    ".b..T..T..b.",
    "............",
    "..W.W..W.W..",
    "............",
    "...........S"
  ],
  "critters": [
    {
      "kind": "rabbit",
      "x": 8,
      "y": 6
    },
    {
      "kind": "squirrel",
      "x": 8,
      "y": 0
    },
    {
      "kind": "squirrel",
      "x": 1,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 3,
      "y": 4
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 4,
      "y": 5
    },
    {
      "kind": "coin",
      "x": 8,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 9,
      "y": 8
    },
    {
      "kind": "coin",
      "x": 6,
      "y": 10
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 10,
      "y": 11
    }
  ],
  "moles": {
    "hills": 2,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 63,
  "biome": "golf",
  "par": {
    "reel": 6578,
    "push": 5438,
    "selfPropelled": 4968,
    "tractor": 4500,
    "zeroTurn": 3423,
    "fairway": 2110
  },
  "routeTries": {
    "par": {
      "reel": 19,
      "push": 18,
      "selfPropelled": 5,
      "tractor": 3,
      "zeroTurn": 24,
      "fairway": 18
    }
  }
}
